import React, { useEffect, useState } from 'react';

const DISMISS_KEY = 'pwa_install_dismissed_until';

const InstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [show, setShow] = useState(false);
  const [isIos, setIsIos] = useState(false);

  useEffect(() => {
    // Don't show if already installed (running in standalone mode)
    if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) return;

    // Don't show if user recently dismissed
    const dismissedUntil = localStorage.getItem(DISMISS_KEY);
    if (dismissedUntil && Date.now() < Number(dismissedUntil)) return;

    // Detect iOS Safari (no beforeinstallprompt — needs manual instruction)
    const ua = window.navigator.userAgent;
    const ios = /iphone|ipad|ipod/i.test(ua) && !window.MSStream;
    if (ios) {
      setIsIos(true);
      setShow(true);
      return;
    }

    // Android / Chrome — listen for native install prompt
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setShow(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') setShow(false);
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShow(false);
    // Don't show again for 7 days
    localStorage.setItem(DISMISS_KEY, Date.now() + 7 * 24 * 60 * 60 * 1000);
  };

  if (!show) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-[100] md:left-auto md:right-4 md:w-[360px]"
      style={{ filter: 'drop-shadow(0 4px 20px rgba(0,0,0,0.12))' }}>
      <div className="bg-white rounded-2xl p-4 border border-[#e5e5e5]">
        <div className="flex items-start gap-3">
          {/* App icon */}
          <div className="w-12 h-12 rounded-xl bg-[#3fb5d2] flex flex-col items-center justify-center flex-shrink-0 gap-0.5">
            <span className="text-white font-extrabold text-[11px] leading-none tracking-tight" style={{ fontFamily: 'Inter, Arial Black, sans-serif' }}>SINII</span>
            <svg viewBox="0 0 24 24" fill="white" className="w-3 h-3">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 16.77l-6.18 3.25L7 13.14 2 9.27l6.91-1.01z"/>
            </svg>
          </div>

          <div className="flex-1 min-w-0">
            <p className="text-[14px] font-semibold text-[#3b3b3b] leading-5">Tambahkan ke Layar Utama</p>
            <p className="text-[12px] text-[#8a8a8a] mt-0.5 leading-4">
              {isIos
                ? 'Buka menu Share lalu ketuk "Add to Home Screen"'
                : 'Akses SINII Plus langsung dari layar utama HP seperti aplikasi.'}
            </p>
          </div>

          {/* Close */}
          <button onClick={handleDismiss} className="text-[#c0c0c0] hover:text-[#8a8a8a] transition-colors flex-shrink-0 mt-0.5">
            <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4">
              <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd"/>
            </svg>
          </button>
        </div>

        {!isIos && (
          <div className="flex gap-2 mt-3">
            <button onClick={handleInstall}
              className="flex-1 py-2 text-[13px] font-semibold bg-[#3fb5d2] hover:bg-[#2a798c] text-white rounded-xl transition-colors">
              Pasang Sekarang
            </button>
            <button onClick={handleDismiss}
              className="px-4 py-2 text-[13px] font-medium text-[#646464] border border-[#e5e5e5] hover:bg-gray-50 rounded-xl transition-colors">
              Nanti
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default InstallPrompt;
